<template>
  <div class="forgot-password mt-5">
    <img src="@/assets/Metals-Direct-Inc-logo.png" alt="" />
    <div class="container-fluid text-center">
      <div class="row justify-content-center">
        <div class="col-12 col-md-4">
          <h1 class="mt-4">Forgot Password</h1>
          <p v-if="!submitted" class="text-left">
            Enter your email address and we'll send you a link to reset your
            password.
          </p>

          <div v-if="!submitted">
            <b-form @submit.prevent="submitForgotPassword">
              <label for="email">Email</label>
              <b-input-group>
                <b-form-input
                  id="email"
                  v-model="email"
                  type="email"
                  :disabled="sending"
                  required
                ></b-form-input>
              </b-input-group>
              <b-button
                class="mt-3"
                type="submit"
                variant="primary"
                :disabled="sending"
              >
                <span v-if="sending">Sending...</span>
                <span v-if="!sending">Send Reset Link</span>
              </b-button>
            </b-form>
            <div class="mt-3">
              <router-link to="/login">Back to Login</router-link>
            </div>
          </div>

          <div v-if="submitted" class="success-message">
            <div class="alert alert-success mt-3" role="alert">
              <strong>Check your email!</strong>
              <p class="mb-0 mt-2">
                If an account exists with that email, we've sent a password
                reset link. Please check your inbox and spam folder.
              </p>
            </div>
            <div class="mt-3">
              <router-link to="/login">Back to Login</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ForgotPasswordPage',
  data: function () {
    return {
      email: '',
      sending: false,
      submitted: false,
    }
  },
  methods: {
    submitForgotPassword() {
      this.sending = true
      const data = { email: this.email }
      return axios
        .post('/services/public/user/forgot-password', data)
        .then(response => {
          this.submitted = true
          this.sending = false
        })
        .catch(error => {
          console.log('error: ', error)
          this.sending = false
          this.$toasted.error(
            error?.response?.data?.error || 'Error sending reset email',
            {
              action: {
                text: 'Close',
                onClick: (e, toastObject) => {
                  toastObject.goAway(0)
                },
              },
            },
          )
        })
    },
  },
}
</script>

<style lang="scss" scoped>
h1 {
  font-size: 24px;
}

label {
  text-align: left;
  font-weight: bold;
  display: block;
}

button {
  width: 100%;
}

.success-message {
  text-align: left;
}

img {
  max-width: 300px;
  margin: 0 auto;
  display: block;
}
</style>


